<template>
  <h-item-menu-divider v-if="content === 'divider'" />
  <div v-else>
    <h-description
      :name="`${content.quantity} ${content.itemName}`"
      :price="content.itemPrice * content.quantity"
      :paid="paid"
    />
    <h-description
      v-for="(modifier, i) in content.modifiers"
      :key="i"
      :name="modifier.name"
      :price="modifier.price * content.quantity"
      :paid="paid"
      indent
    />
  </div>
</template>

<script>
  import HItemMenuDivider from './ItemMenuDivider'
  import HDescription from './ItemDescription'

  export default {
    components: {
      HItemMenuDivider,
      HDescription,
    },

    props: {
      content: {
        required: true,
        type: [String, Object],
      },
      paid: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
